import { DomainEvent } from '../../../../../core/domain/events/domain_event';
import { Cache } from '../../cache/cache';

export class CacheEvent extends DomainEvent<Cache> {}

export class CacheSavedEvent extends DomainEvent<Cache> {}
